"use client";

import { useEffect } from "react";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    if (process.env.NODE_ENV === "development") {
    }
  }, [error]);

  return (
    <html>
      <body>
        <div style={{ 
          display: 'flex', 
          minHeight: '100vh', 
          alignItems: 'center', 
          justifyContent: 'center',
          backgroundColor: '#f3f4f6',
          padding: '16px'
        }}>
          <div style={{
            width: '100%',
            maxWidth: '500px',
            backgroundColor: 'white',
            borderRadius: '8px',
            padding: '32px',
            boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
          }}>
            <h2 style={{ 
              marginBottom: '16px', 
              fontSize: '24px', 
              fontWeight: 'bold',
              color: '#dc2626' 
            }}>
              Critical Application Error
            </h2>
            <div style={{
              marginBottom: '16px',
              padding: '16px',
              backgroundColor: '#f9fafb',
              borderRadius: '4px'
            }}>
              <p style={{ 
                marginBottom: '8px',
                fontSize: '14px',
                fontWeight: '600',
                color: '#374151'
              }}>
                Error Message:
              </p>
              <p style={{ 
                fontSize: '12px',
                color: '#6b7280',
                wordBreak: 'break-word'
              }}>
                {error.message || "Unknown error occurred"}
              </p>
              {error.digest && (
                <p style={{ 
                  marginTop: '8px',
                  fontSize: '12px',
                  color: '#9ca3af'
                }}>
                  Error ID: {error.digest}
                </p>
              )}
              {error.stack && (
                <details style={{ marginTop: '12px' }}>
                  <summary style={{ 
                    cursor: 'pointer',
                    fontSize: '12px',
                    color: '#6b7280'
                  }}>
                    View Stack Trace
                  </summary>
                  <pre style={{
                    marginTop: '8px',
                    fontSize: '10px',
                    color: '#4b5563',
                    overflow: 'auto',
                    maxHeight: '200px'
                  }}>
                    {error.stack}
                  </pre>
                </details>
              )}
            </div>
            <button
              onClick={reset}
              style={{
                width: '100%',
                padding: '8px 16px',
                backgroundColor: '#2563eb',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '14px'
              }}
            >
              Try again
            </button>
          </div>
        </div>
      </body>
    </html>
  );
}

